import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <PublicLayout>
      <div className="max-w-2xl mx-auto text-center py-24 px-4">
        <div className="section-label">404</div>
        <h1 className="mt-2 font-display font-bold text-4xl text-[#0A192F]">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you&apos;re looking for doesn&apos;t exist or has been moved.</p>
        <Link to="/" className="mt-6 inline-block text-[#1E3A8A] font-medium hover:underline">← Back home</Link>
      </div>
    </PublicLayout>
  );
}
